export enum PointFilter {
  ByMyPoints = '73be30d2-cc3e-4ef2-8cea-3a1067b97681',
  ByPointsRange = '1a26c322-e842-4eff-8f0d-4c131d5b81a1',
  AnyValue = '1c10a396-76c4-48c3-858c-6179d05564d2',
}
